import { powerDeparmentsAccionesRoles } from '../../acciones-roles/reportes/power-depatments-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const PowerDeparmentsRoutes: SideBarButton = {
  data: {
    name: 'Departments - Power BI',
    appendUrl: './reportsPBI',
    roles: powerDeparmentsAccionesRoles.sideNavActions.powerDeparmentsPbi,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Hora X Hora',
        url: '/departments/hxh',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Intakes',
        url: '/intakes',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Tanques',
        url: '/tanks',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'HPs',
        url: '/hps',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Plasticos',
        url: '/plastics',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Lids',
        url: '/lids',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Polyurethane',
        url: '/polyurethane',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Injection Molding',
        url: '/injection-molding',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Compression',
        url: '/compression',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Mezclado',
        url: '/compounding',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Mangueras',
        url: '/hoses',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'CNC',
        url: '/cnc',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Pliegues',
        url: '/pleat-packs',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Filtros',
        url: '/filters',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Nave 4',
        url: '/nave4',
      },
      options: PreConfigButton3,
    },
  ],
};
